var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DoubleSide, Mesh, MeshBasicMaterial, MeshPhongMaterial } from "three";
import { PreloadableMeshProviderBase } from "./PreloadableMeshProviderBase";
import { addBarycentricCoordinates, createWireframeMaterial } from "../rendering/shader/BarycentricWireframe";
export class HeadMeshProvider extends PreloadableMeshProviderBase {
    constructor() {
        super("meshes/heads/Head_VR");
    }
    getHeadMesh(connection) {
        return __awaiter(this, void 0, void 0, function* () {
            const mesh = yield this.getMesh(connection);
            this.createNewMaterial(mesh);
            return mesh;
        });
    }
    /**
     * Each avatar can have a different attributes,
     * therefore a new material is needed for each mesh
     */
    createNewMaterial(mesh) {
        mesh.traverse((child) => {
            if (child instanceof Mesh) {
                if (child.name === "MonitorScreen") {
                    child.material = new MeshBasicMaterial();
                    return;
                }
                if (child.name.startsWith("Indicator")) {
                    const material = Array.isArray(child.material) ? child.material[0] : child.material;
                    if (material && "map" in material) {
                        child.material = new MeshBasicMaterial({
                            map: material.map,
                            transparent: true,
                            alphaTest: 0.1,
                            side: DoubleSide,
                            color: material.color
                        });
                    }
                    return;
                }
                if (child.name === "VRGlasses_colorFrame") {
                    child.material = new MeshPhongMaterial();
                    return;
                }
                addBarycentricCoordinates(child.geometry);
                child.material = createWireframeMaterial();
            }
        });
    }
}
